import React from 'react';
import TextInput from '../../components/form/TextInput';
import TextInputWithUploader from '../../components/form/TextInputWithUploader';
import TextArea from "../../components/form/TextArea";
import Select from "../../components/form/Select";
import SelectAjax from "../../components/form/SelectAjax";
import BtBloco from '../../components/buttons/BtBloco';
import DateRangePickerWrapper from "../../components/form/DateRangePickerWrapper";
import Component from "../blocos-planilha/Component";
import Ws from '../../config/Ws';
import Requisitions from "../../utils/requisitions/Requisitions";
import TIPOS_PLANILHA from "../../data/TiposPlanilha";
import Random from "../../utils/strings/Random";
import Alert from "../../components/alert/Alert";
import SimpleAlert from "../../components/alert/types/SimpleAlert";
import DAYS from "../../data/DaysHome";
import STRINGS from './../../data/language/language';

const CLASS_TIPO_PLANILHA = " wrapper-tipo-planilha ";
const MAX_PLANILHAS = DAYS.length;

class TipoPlanilha extends React.Component{
  constructor(props){
    super(props);
    this.state = {
      id:props.id,
      ativo:0,
      dados:props.data,
      strings:STRINGS[window.LANGUAGE],
    }

    this.toggleBoxes = this.toggleBoxes.bind(this);
    this.handleSelectChange = this.handleSelectChange.bind(this);
    this.addBlocoPlanilha = this.addBlocoPlanilha.bind(this);
  }

  componentDidMount() {

  }

  toggleBoxes (e){
    e.preventDefault();
    let _id = e.currentTarget.getAttribute("data-id");
    this.setState({ativo:_id});
  }//end toggle boxes

  handleSelectChange (__args__){
    var _self = this;

    Requisitions({
      url:Ws.blocos_planilha.detalhe,
      data:{id:__args__.value},
      sucess:function(data){
        _self.addBlocoPlanilha(data.item);
      },
      error:function(data){

      }
    });
  }

  addBlocoPlanilha(__args__){

    let modal = new Alert();

    if(this.state.dados.blocos && (this.state.dados.blocos.length >= MAX_PLANILHAS)){
      modal.open({
        page:
        <SimpleAlert
        title="Atenção"
        message="Somente são permitidos 2 Blocos de planilha. Uma para 2, 3 dias de treino!"
        />,
        animation:Alert.ANIMATION_INCREASE
      });
      return false;
    }

    const _ativo = this.state.dados.blocos ? this.state.dados.blocos.length : 0;
    const _arr = this.state.dados.blocos ? this.state.dados.blocos : [];
    const _dados = [..._arr,__args__]

    this.setState({
      dados:{blocos:_dados},
      ativo:_ativo
    });
  }

  render(){
    let _id = this.state.id;
    let _classes = CLASS_TIPO_PLANILHA+(this.props.ativo ? "ativo" : "");
    const sexoAtivo = this.props.sexoAtivo;

    const dadosArray = this.state.dados.blocos ? this.state.dados.blocos : [];


    //listagem dos botões
    const listButtons = dadosArray.map((bloco,i)=>{
      const _ativo = this.state.ativo==i ? true : false;
      const _id = i;
        return (
          <BtBloco
            onClick={this.toggleBoxes}
            key={i.toString()}
            value={i+2}
            ativo={_ativo}
            dataId={_id}>
          </BtBloco>
        )
      }
    );//end map

    //listagem dos blocos
    const listBoxes = dadosArray.map((bloco,i)=>{
      let qdias = bloco.qtde_dias;
      const _ativo = this.state.ativo==i ? "ativo" : '';
        return (
           <Component
            sexoAtivo={sexoAtivo}
            ativarBox={_ativo}
            key={i}
            dados={bloco}
            qntDias={qdias}>
           </Component>
        )
      }
    );//end map

    const
    {
      cadencia,
      intervalo
    } = this.state.dados;

    const
    {
      titlePlanilhasTreino,
      seriesRepeticoes,
      digiteAqui,
      intervaloTitle,
      cadenciaTitle,
      adiconarBlocoPlanilhaHome,
      circuito,
      sessoes,
      repeticoes,
      observacoes
    } = this.state.strings;

    const obsTitle = this.state.strings.observacoes;

    const circuitoVal = this.state.dados.circuito;
    const repeticoesVal = this.state.dados.repeticoes;
    const sessoesVal = this.state.dados.sessoes;
    const cadenciaVal = this.state.dados.cadencia;
    const observacoesBloco = this.props.detalhe ? this.props.detalhe.observacoes : '';

    return(
      <div className={_classes} id={_id} data-id={this.props.identifier}>
        <div className="wrapper-tipo-planilha__inner">
          <div data-id='js-detalhes-tipo-planilha'>
            <div className="pure-u-6-24">
              <TextInput
                name="circuito"
                title={circuito}
                placeholder={digiteAqui}
                value={circuitoVal}
              />
            </div>
            <div className="pure-u-6-24">
              <TextInput
                name="repeticoes"
                title={repeticoes}
                placeholder={digiteAqui}
                value={repeticoesVal}
              />
            </div>
            <div className="pure-u-6-24">
              <TextInput
                name="sessoes"
                title={sessoes}
                placeholder={digiteAqui}
                value={sessoesVal}
              />
            </div>
            <div className="pure-u-6-24">
              <TextInput
                name="cadencia"
                title={cadenciaTitle}
                placeholder={digiteAqui}
                value={cadenciaVal}
              />
            </div>
            <div className="">
              <TextArea
                name="observacoes"
                title={observacoes}
                value={observacoesBloco}
                placeholder="">
              </TextArea>
            </div>
          </div>
          <br />
          <div className="separador"></div>
          <br />
          <div>
            <div className="pure-u-15-24">
              <SelectAjax
                url={Ws.blocos_planilha.search}
                onChange={this.handleSelectChange}
                title={adiconarBlocoPlanilhaHome}
              />
            </div>
            <div className="pure-u-9-24">
              {listButtons}
            </div>
          </div>
          <br />
          {listBoxes}
        </div>
      </div>
    )
  }
}

export default TipoPlanilha;



// WEBPACK FOOTER //
// ./src/classes/treino-home/TipoPlanilha.js